import { createApi } from '@reduxjs/toolkit/query/react';

import { ReasonCatalogResponse } from '../types/IReasonCode';

import { axiosBaseQuery } from '@/redux/axios';
import { apiRoutes } from '@/api/apiRoutes';
import { GetReasonCodesParams } from '@/api/types';

export const reasonCodesApi = createApi({
  reducerPath: 'reasonCodesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['ReasonCodes'],
  endpoints: (builder) => ({
    getReasonCodes: builder.query<
      ReasonCatalogResponse,
      GetReasonCodesParams | void
    >({
      query: (params) => ({
        url: apiRoutes.getReasonCodes.path(params ?? {}),
        method: apiRoutes.getReasonCodes.method,
      }),
      providesTags: ['ReasonCodes'],
    }),
  }),
});

export const { useGetReasonCodesQuery } = reasonCodesApi;
export default reasonCodesApi;
